// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1OBDI","emails":"CreateEditClinics_emails__3d-JT","emailTagLabel":"CreateEditClinics_emailTagLabel__2-XUg"};